<div>
  <mat-form-field class="filter-form" style="flex:1;width:100%;">
    <span matPrefix style="padding-left: 20px;"></span>
    <input matInput [formControl]="filterField" placeholder="Buscar">
  </mat-form-field>
</div>